import React, { useRef, useState } from "react";
import { Tooltip } from "@mui/material";

import styles from "./DataTableCell.module.css";

export const DataTableCell = ({
  content,
  fullText,
  clickable,
  clickableSubtle,
  wrap,
  onClick,
  noDim,
  "data-testid": testId,
}) => {
  const contentRef = useRef(null);
  const [tooltipTitle, setTooltipTitle] = useState("");

  const handleMouseEnter = () => {
    const el = contentRef.current;
    if (!el) return;
    if (el.scrollWidth > el.clientWidth) {
      const title = fullText ?? el.textContent?.trim() ?? "";
      if (title) setTooltipTitle(title);
    }
  };

  const handleMouseLeave = () => {
    setTooltipTitle("");
  };

  return (
    <div className={`${styles.cell} ${wrap ? styles.cellWrap : ""}`} {...(testId && { "data-testid": testId })} {...(noDim && { "data-no-dim": true })}>
      <Tooltip title={tooltipTitle} placement="top" enterDelay={200}>
        <div
          ref={contentRef}
          className={`${styles.cellContent} ${wrap ? styles.wrap : ""} ${clickableSubtle ? styles.clickableSubtle : clickable ? styles.clickable : ""}`}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={clickable || clickableSubtle ? onClick : undefined}
          role={clickable || clickableSubtle ? "button" : undefined}
          tabIndex={clickable || clickableSubtle ? 0 : undefined}
          onKeyDown={
            (clickable || clickableSubtle) && onClick
              ? (e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onClick(e);
                  }
                }
              : undefined
          }
        >
          {content}
        </div>
      </Tooltip>
    </div>
  );
};
